import type { FC, ReactNode } from "react";
import { Text } from "react-aria-components";
import { fieldStyle } from "./style.js";

export interface FieldDescriptionProps {
  children: ReactNode;
  /**
   * Only needed outside a react-aria field, where the caller wires the
   * control's `aria-describedby` itself.
   */
  id?: string;
  className?: string;
}

/**
 * Help text for a form field, rendered below the control.
 *
 * Place it inside a react-aria field (`Combobox`, `TextField`, `Select`, ...)
 * and the control is described by it automatically — react-aria hands out the
 * id through its `description` slot. Outside one, pass an `id` and reference it
 * from the control's `aria-describedby`.
 */
export const FieldDescription: FC<FieldDescriptionProps> = (props) => {
  const { children, id, className } = props;

  return (
    <Text
      className={fieldStyle().description({ className })}
      elementType="p"
      id={id}
      slot="description"
    >
      {children}
    </Text>
  );
};
